import { useTheme } from "@mui/material";
import { green, grey, lightBlue, orange, purple, teal } from "@mui/material/colors";
export const CodeColors = {
    literal: orange,
    number: lightBlue,
    string: green,
    key: purple,
    punctuation: grey,
    className: teal,
};
export function useThemeShade() {
    const theme = useTheme();
    return theme.palette.mode == "light" ? 700 : 300;
}
export function useCodeColors() {
    const theme = useTheme();
    const shade = useThemeShade();
    const colors = Object.entries(CodeColors)
        .map(([key, value]) => [key, value[shade]])
        .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
    }, {});
    return Object.assign(Object.assign({}, colors), { keyword: theme.palette.primary.main });
}
//# sourceMappingURL=code-colors.js.map